export const EMPLOYEE_FILTER_NAME = "Employees";
export const TYPE_FILTER_NAME = "LeaveType";
export const UN_APPROVED_PTO = "unApprovedPTO";
export const TableColumns = [
  { label: "Employee", field: "employee" },
  { label: "Type", field: "type" }
];
